interface IBaseToastMessageBoxProps {
  message: string;
  position: string;
  startElement?: React.ReactNode;
}

export default function BaseToastMessageBox({
  startElement,
  position,
  message
}: IBaseToastMessageBoxProps) {
  return (
    <div
      className={`flex flex-row w-fit items-center mx-auto ${
        position === 'top' ? 'mt-[130px]' : 'mb-[130px]'
      } px-[16px] py-[10px] rounded-[30px] bg-black/55 dark:bg-white/90`}
      style={{
        maxWidth: 'calc(var(--chakra-sizes-xl))',
        backdropFilter: 'blur(40px)',
        boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.04)'
      }}
    >
      {startElement && (
        <div className="flex mr-[4px] items-start flex-shrink-1">{startElement}</div>
      )}
      <div className="flex-grow text-[14px] font-medium text-separator-light-1 dark:text-separator-dark-1">
        {message}
      </div>
    </div>
  );
}
